import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import PlatPersonnalisePage from '@/pages/plat-personnalise/page';
import InfoAlimentPage from '@/pages/info-aliment/page';
import ContactPage from '@/pages/contact/page';
import AdminPage from '@/pages/admin/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/plat-personnalise', element: <PlatPersonnalisePage /> },
  { path: '/info-aliment', element: <InfoAlimentPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '/idee-plat', element: <NotFound /> },
  { path: '*', element: <NotFound /> },
];

export default routes;